import { DriverGroupDto } from '@cargovibe/shared-types';

export function toGroupsByUserId(groups: DriverGroupDto[]): Map<string, DriverGroupDto[]> {
  const groupsByUserId: Map<string, DriverGroupDto[]> = new Map<string, DriverGroupDto[]>();

  for (const group of groups) {
    for (const memberId of group.memberIds) {
      const existing: DriverGroupDto[] = groupsByUserId.get(memberId) ?? [];
      existing.push(group);
      groupsByUserId.set(memberId, existing);
    }
  }

  return groupsByUserId;
}
